export default __webpack_public_path__ + "static/media/5.3.02d2d25a.webm";